import { render, staticRenderFns } from "./FreightTableRouteCharacteristics.vue?vue&type=template&id=350d00fe&scoped=true"
import script from "./FreightTableRouteCharacteristics.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteCharacteristics.vue?vue&type=style&index=0&id=350d00fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350d00fe",
  null
  
)

export default component.exports